module.exports = __webpack_public_path__ + "static/media/wn_3.afb4dde0.jpg";